export const primaryColor = '#06182f'
export const backgroundColor = '#ffffff'
export const primaryBackgroundColor = '#14253c'
export const secondaryBackgroundColor = '#122842'
export const transparentWhiteBackground = 'rgba(255, 255, 255, 0.03)'
export const transparentWhiteBackgroundLighter = 'rgba(255, 255, 255, 0.07)'
export const lightGreen = '#6eb305'
export const lightRed = '#e40000'
export const lightOrange = '#e74e0f'

export const bottomMenuHeight = '47px'
export const headerMenuHeight = '78px'
export const sideMenuWidth = '320px'

export const tableHeaderGray = '#f3f5f9'

// New design vars
export const white = '#ffffff'
export const primary = '#14253c'
export const secondary = '#060606'
export const primaryText = secondary
export const orange = '#f96700'
export const orangeHovered = 'rgb(174, 72, 0)'
export const dividerPrimary = '#e1e1e1'
export const label = '#cbcbcb'
export const labelSecondary = '#f1f2f3'
export const valueSecondary = '#616264'
export const headerText = '#fbfbfb'
export const category = '#4f5c6d'
export const temporaryClosed = '#b8bec4'
export const boxShadow = '0px 1px 12px rgba(0, 0, 0, 0.12)'
export const boxShadowButton = '0px 2px 2px rgba(0, 0, 0, 0.2)'
export const BORDER_RADIUS = '10px'
export const BORDER_RADIUS_SMALL = '5px'
export const TOGGLE_GROUP_BACKGROUND = '#e5e5e5'
export const TRANSITION_SIMPLE = 'all 0.25s ease-in'
export const TRANSITION_CUBIC = 'cubic-bezier(0.4, 0, 0.2, 1) 0ms'
export const TRANSITION_BACKGROUND = `background-color 250ms ${TRANSITION_CUBIC},box-shadow 250ms ${TRANSITION_CUBIC},border-color 250ms ${TRANSITION_CUBIC},color 250ms ${TRANSITION_CUBIC}`
